import React, {useState} from 'react';
import FadeSlideIn from "../../common/FadeSlideIn";
import leaderboardHeader from "../../../resources/leaderboardHeader.png";
import logoRoll from "../../../resources/logoRoll.png";
import logoLuxdrop from "../../../resources/luxdropLogo.png";
import logoHypedrop from "../../../resources/logoHypedrop.png";
import logoCSGOBIG from "../../../resources/logoCSGOBIG.png";
import logoRAINGG from "../../../resources/logoRAINGG.svg";
import logoStake from "../../../resources/logoStake.png";
import RollLeaderboard from "../leaderboard/RollLeaderboard";
import LuxdropLeaderboard from "../leaderboard/LuxdropLeaderboard";
import CasesLeaderboard from "../leaderboard/CasesLeaderboard";
import StakeLeaderboard from "../leaderboard/StakeLeaderboard";
import HypedropLeaderboard from "../leaderboard/HypedropLeaderboard";
import BigLeaderboard from "../leaderboard/BigLeaderboard";
import RainggLeaderboard from '../leaderboard/RainggLeaderboard';

const LandingLeaderboards = () => {

    const [shownLeaderboard, setShownLeaderboard] = useState(4);

    return (<FadeSlideIn>
        <div className="landingLeaderboards">
            <div className={`leaderboardBackdrop min`}>
                <div className={`container`}>

                    <div className="leaderboardHeader">

                        <img src={leaderboardHeader} alt=""/>

                        <div className="leaderboardSwitcher">
                            <a className={`leaderboardStake ${shownLeaderboard == 1 ? 'active' : ''}`}
                               onClick={() => setShownLeaderboard(1)}>
                                <img src={logoStake} alt=""/>
                            </a>
                            <a className={`leaderboardClash ${shownLeaderboard == 4 ? 'active' : ''}`}
                               onClick={() => setShownLeaderboard(4)}>
                                <img src={logoLuxdrop} alt=""/>
                            </a>
                            <a className={`leaderboardClash ${shownLeaderboard == 3 ? 'active' : ''}`}
                               onClick={() => setShownLeaderboard(3)}>
                                <img src={logoRoll} alt=""/>
                            </a>
                            <a className={`leaderboarHypedrop ${shownLeaderboard == 5 ? 'active' : ''}`}
                               onClick={() => setShownLeaderboard(5)}>
                                <img src={logoHypedrop} alt=""/>
                            </a>
                            <a className={`leaderboardRaingg ${shownLeaderboard == 6 ? 'active' : ''}`}
                               onClick={() => setShownLeaderboard(6)}>
                                <img src={logoRAINGG} alt=""/>
                            </a>
                        </div>

                    </div>

                    <div>
                        {shownLeaderboard == 1 && <StakeLeaderboard showMinimalDetails={true}/>}
                        {shownLeaderboard == 3 && <RollLeaderboard showMinimalDetails={true}/>}
                        {shownLeaderboard == 4 && <LuxdropLeaderboard showMinimalDetails={true}/>}
                        {shownLeaderboard == 5 && <HypedropLeaderboard showMinimalDetails={true}/>}
                        {shownLeaderboard == 6 && <RainggLeaderboard showMinimalDetails={true}/>}
                    </div>


                </div>

            </div>
        </div>
    </FadeSlideIn>);
}
export default LandingLeaderboards;